import { ReactElement } from "react";

export default function IconHardDrive(): ReactElement {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.67703 2.25C3.96145 2.25 3.31796 2.68566 3.0522 3.35007L1.37517 7.54265C1.36083 7.57848 1.34771 7.61472 1.33581 7.65132C1.28101 7.75549 1.25 7.87412 1.25 8C1.25 8.02583 1.25131 8.05135 1.25385 8.0765C1.25129 8.11509 1.25 8.15381 1.25 8.19258V12C1.25 12.9665 2.0335 13.75 3 13.75H13C13.9665 13.75 14.75 12.9665 14.75 12V8.19258C14.75 8.15381 14.7487 8.11509 14.7461 8.0765C14.7487 8.05135 14.75 8.02583 14.75 8C14.75 7.87412 14.719 7.75549 14.6642 7.65132C14.6523 7.61472 14.6392 7.57848 14.6248 7.54265L12.9478 3.35007C12.682 2.68566 12.0386 2.25 11.323 2.25H4.67703ZM12.8922 7.25L11.5551 3.90715C11.5171 3.81224 11.4252 3.75 11.323 3.75H4.67703C4.57481 3.75 4.48288 3.81224 4.44491 3.90715L3.10777 7.25H12.8922ZM2.75 8.75V12C2.75 12.1381 2.86193 12.25 3 12.25H13C13.1381 12.25 13.25 12.1381 13.25 12V8.75H2.75ZM12.25 10.5C12.25 10.9142 11.9142 11.25 11.5 11.25C11.0858 11.25 10.75 10.9142 10.75 10.5C10.75 10.0858 11.0858 9.75 11.5 9.75C11.9142 9.75 12.25 10.0858 12.25 10.5ZM9.25 11.25C9.66421 11.25 10 10.9142 10 10.5C10 10.0858 9.66421 9.75 9.25 9.75C8.83579 9.75 8.5 10.0858 8.5 10.5C8.5 10.9142 8.83579 11.25 9.25 11.25Z"
        fill="#071722"
        fillOpacity="0.84"
      />
    </svg>
  );
}
